import React, { Component } from "react";
import "./ErrorBoundary.css";
import {
  connexion,
  errorBoundaryPromise,
} from "../Checkout/components/promessesAxios";
import Cookies from "js-cookie";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const token = Cookies.get("auth_token");
    const payload = {
      message: error?.message ?? "unknown error",
      stack: error?.stack ?? null,
      componentStack: info?.componentStack ?? null,
      userAgent: navigator.userAgent,
      url: window.location.href,
      time: new Date().toISOString(),
    };

    console.error("🔥 Error Boundary CATCH:", payload);

    if (token) {
      errorBoundaryPromise(token, payload);
    } else {
      connexion()
        .then((res) => {
          if (res.token) {
            errorBoundaryPromise(res.token, payload);
          }
        })
        .catch(() => {});
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-page">
          <div className="error-boundary-box">
            <div className="error-boundary-icon">⚠️</div>
            <h1>Une erreur est survenue</h1>
            <p>
              Merci d’actualiser la page. <br />
              Si le problème persiste, veuillez rapporter cette erreur à notre
              service technique.
            </p>
          </div>
          <p className="error-boundary-footer">
            © {new Date().getFullYear()} EVE Éducation
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
